// extracted by mini-css-extract-plugin
export default {"animate-fetching":"_7x2rw2iOwnVg5ZiOj1ypow==","animate":"vO9QH-RClW8jn8NjLz1q3g=="};